import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import Currency from "../components/Currency";
import {FormattedMessage} from "react-intl";

const getRecursiveTableColumns = (blocks, intl) => {
  return blocks
    .filter((b) => b.type !== "output")
    .map((block) => ({
      title: block.column_name
        ? intl.formatMessage({
            id: block.column_name,
            defaultMessage: block.column_name,
          })
        : "",
      field: `${block.id}`,
      type:
        block.input_type === "bool" || block.type === "alert"
          ? "boolean"
          : "string",
      render: (row) => {
        if (block.input_type === "bool" || block.type === "alert") {
          if (row[block.id]) {
            return (
              <div className="w-8 h-8 text-green-400">
                <CheckCircleIcon />
              </div>
            );
          } else {
            return (
              <div className="w-8 h-8 text-red-400">
                <XCircleIcon />
              </div>
            );
          }
        }

        if (block.output_currency) {
          return <Currency value={row[block.id]} />;
        }

        if (Array.isArray(row[block.id]) && row[block.id].length > 1)
          return <ul className="list-disc list-inside">
            {row[block.id].map((entry, idx) => <li key={idx}>{entry}</li>)}
          </ul>

        return row[block.id] || (
          <span className="text-gray-400">
            <FormattedMessage id="none" />
          </span>
        );
      },
    }));
};

export default getRecursiveTableColumns;
